import CryptoJS from 'crypto-js';
import jwt_decode from 'jwt-decode';

/**
 * Token'ı güvenli şekilde çözer. Token yoksa, bozuksa veya geçersizse
 * hata fırlatmak yerine null döner. Böylece render sırasında uygulama çökmez.
 */
export const safeJwtDecode = (token) => {
  if (!token || typeof token !== 'string') return null;
  try {
    return jwt_decode(token);
  } catch (err) {
    return null;
  }
};

/** Token'ın var olup olmadığını ve süresinin dolup dolmadığını kontrol eder. */
export const isTokenValid = (token) => {
  const user = safeJwtDecode(token);
  if (!user) return false;
  if (user.exp && new Date(user.exp * 1000) <= new Date()) return false;
  return true;
};

export const encryptData = (data, salt) =>
  CryptoJS.AES.encrypt(JSON.stringify(data), salt).toString();


export const decryptData = (ciphertext, salt) => {
  const bytes = CryptoJS.AES.decrypt(ciphertext, salt);
  try {
     return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }
  catch(err){
    return null;
  }
}

/** Query string'de + ve özel karakterlerin bozulmaması için (login şifresi vb.) */
export const buildCheckUserLoginUrl = (userName, userPassword, isLdapLogin = false) =>
  `api/Login/checkUserLogin?userName=${encodeURIComponent(userName)}&userPassword=${encodeURIComponent(userPassword)}&isLdapLogin=${isLdapLogin}`;

/** checkUserLogin API yanıtını normalize eder */
export const parseCheckUserLoginResponse = (response) => ({
  token: response.Token,
  passwordExpired:
    response.passwordExpired === true || response.PasswordExpired === true,
  message: response.message || response.Message || "",
  passwordExpiringSoon: response.PasswordExpiringSoon === true,
  warningMessage: response.WarningMessage || "",
});

/**
 * Giriş yanıtını işler: önce şifre süresi, sonra başarılı giriş, sonra kimlik hatası.
 * @returns {'passwordExpired'|'success'|'invalidCredentials'}
 */
export const handleCheckUserLoginResponse = (response, { onPasswordExpired, onSuccess, onInvalidCredentials }) => {
  const parsed = parseCheckUserLoginResponse(response);

  if (parsed.passwordExpired) {
    onPasswordExpired?.(parsed);
    return "passwordExpired";
  }

  if (parsed.token) {
    onSuccess?.(parsed);
    return "success";
  }

  onInvalidCredentials?.(parsed);
  return "invalidCredentials";
};

export const buildLogin3rdPartAppUrl = (username, password, companyName) =>
  `api/Login/Login3rdPartApp?Username=${encodeURIComponent(username)}&Password=${encodeURIComponent(password)}&CompanyName=${encodeURIComponent(companyName)}`;